import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { vitecompanyserviceurl } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor, acceptExceptAuthErrors } from "src/utils/axiosRefreshInterceptor";

const companyserviceurl: AxiosInstance = axios.create({
  baseURL: vitecompanyserviceurl + "/api/v1/oms",
});

const companyserviceurlevent: AxiosInstance = axios.create({
  baseURL: vitecompanyserviceurl,
});

companyserviceurl.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
companyserviceurlevent.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));

// Attach 403 refresh-and-retry interceptors
attachRefreshInterceptor(companyserviceurl);
attachRefreshInterceptor(companyserviceurlevent);

export const getStockistBlockList = (
  is_blocked?: boolean | undefined,
  pageIndex?: number,
  perPage?: number,
  filtersQuery?: string,
  search?: string,
  company_code?: number
) => {
  const queryParams = new URLSearchParams();

  if (is_blocked !== undefined) queryParams.append("is_blocked", String(is_blocked));
  if (pageIndex !== undefined) queryParams.append("page", pageIndex.toString());
  if (perPage !== undefined) queryParams.append("perPage", perPage.toString());
  if (search !== undefined) queryParams.append("search", search.toString());

  let url = `/stockist_block?${queryParams.toString()}`;

  if (filtersQuery) {
    url += `&${filtersQuery}`;
  }

  return companyserviceurl.get(url, {
    headers: {
      company_code: company_code || 0,
    },
  });
};

export const updateStockistBlockRevoke = (payload: any, company_code: number) => {
  return companyserviceurlevent.post(
    `/event/stockist_block/add`,
    payload,
    {
      headers: {
        company_code: company_code || 0,
      },
      validateStatus: acceptExceptAuthErrors,
    }
  );
};
// M10-14613
export const getStockistBlockLogs = (
  domain_primary_key: number,
  page: number,
  limit: number,
  company_code: number
) => {
  return companyserviceurl.get(
    `/stockist_block/logs?domain_primary_key=${domain_primary_key}&page=${page}&limit=${limit}`,
    {
      headers: {
        company_code: company_code || 0,
      },
    }
  );
};
// M10-14613




